import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { formatDateTime } from '@atheneum/api/dist/lib'

import MessageSentIcon from '@components/Icon/MessageSent'

class InterviewScheduleSuccess extends Component {
  static propTypes = {
    modalStore: PropTypes.object
  }

  renderMessage (schedule = {}) {
    const { expertInvitationSentDate, clientInvitationSentDate } = schedule

    if (expertInvitationSentDate && clientInvitationSentDate) {
      return (
        <div className='interview-schedule-done__text m-b-xxl'>
          Calendar invite with instructions is sent to both <br />
          expert and client contacts
        </div>
      )
    }

    if (expertInvitationSentDate) {
      return (
        <div className='interview-schedule-done__text m-b-xxl'>
          Calendar invite with instructions is sent to expert
        </div>
      )
    }

    if (clientInvitationSentDate) {
      return (
        <div className='interview-schedule-done__text m-b-xxl'>
          Calendar invite with instructions is sent to client contacts
        </div>
      )
    }

    return (
      <div className='interview-schedule-done__text m-b-xxl'>
        Calendar invite with instructions wasn't sent to <br />
        neither expert nor client contacts
      </div>
    )
  }

  render () {
    const { modalStore } = this.props
    const { schedule } = modalStore.props

    return (
      <div className='interview-schedule-done'>
        <MessageSentIcon className='m-b-xxl' />

        <h1 className='interview-schedule-done__title'>
          Interview is scheduled on
          <br />
          {schedule && formatDateTime(schedule.startTime)}
        </h1>

        {this.renderMessage(schedule)}

        <button
          className='button interview-schedule-done__button'
          onClick={modalStore.close}
        >
          Return to pipeline
        </button>
      </div>
    )
  }
}

InterviewScheduleSuccess.defaultProps = {
  shouldCloseOnOverlayClick: false,
  hideButtons: true,
  showCloseIcon: false
}

export default inject('modalStore')(observer(InterviewScheduleSuccess))
